import { useTranslation } from 'react-i18next';

import { TablePaginationProps } from '@material-ui/core/TablePagination';

import { StyledTablePagination } from './styled';

/*
 * This component implement a styled version of the TablePagination component.
 */

const CustomTablePagination = (props: TablePaginationProps) => {
    const { t } = useTranslation();

    return (
        <StyledTablePagination
            // @ts-ignore
            component='div'
            backIconButtonText={t('pagination.prev_page')}
            nextIconButtonText={t('pagination.next_page')}
            labelRowsPerPage={t('pagination.rows')}
            labelDisplayedRows={({from, to, count}) => {
                return t('pagination.label', { from, to, count });
            }}
            {...props}
        />
    );
};

export default CustomTablePagination;
